module.exports = __webpack_public_path__ + "img/5_115.33acae3b.png";